import * as echarts from "echarts";

echarts.registerLocale('pt-BR', {
  time: {
    month: [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ],
    monthAbbr: [
      'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
      'jul', 'ago', 'set', 'out', 'nov', 'dez'
    ],
    dayOfWeek: [
      'domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'
    ],
    dayOfWeekAbbr: [
      'dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'
    ]
  }
});

export {}; // ensures this file is treated as a module
